/* GENERATED with v0.0.117 of https://github.beeone.at/George/ibo
 * FROM v2.7.1 of "Payments service"
 * CHANGES WILL BE LOST, DO NOT MAKE MANUAL CHANGES
 */
/* istanbul ignore file */
/* eslint-disable */

import type { CurrencyCode } from './CurrencyCode';
import type { IsoDate } from './IsoDate';
import type { MoneyAmount } from './MoneyAmount';
import type { RateMultiplier } from './RateMultiplier';

export type ExchangeRateInfo = {
    fixedCurrency: CurrencyCode;
    fixedCurrencyRateUnit: number;
    rateMultiplier: RateMultiplier;
    variableCurrencyRate: MoneyAmount;
    variableCurrencyMiddleRate?: MoneyAmount;
    conversionCost?: MoneyAmount;
    dateOfRate?: IsoDate;
    rateType?: ExchangeRateInfo.rateType;
};

export namespace ExchangeRateInfo {

    export enum rateType {
        LIVE = 'LIVE',
        INFORMATIVE = 'INFORMATIVE',
        STANDARD = 'STANDARD',
        INDIVIDUAL = 'INDIVIDUAL',
        INFORMATIVE_WITH_DISCOUNT = 'INFORMATIVE_WITH_DISCOUNT',
        UNKNOWN = 'UNKNOWN',
    }


}

